var _rect, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgSquareWithTick(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 4,
    fill: "#FFEDF3"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.941 6.84488L10.2961 15.1043L7.26571 11.8362C6.90919 11.4202 6.25557 11.4202 5.89905 11.7767C5.54253 12.1333 5.48311 12.7869 5.83963 13.1434L9.70193 17.3028C9.88019 17.4811 10.1773 17.5999 10.415 17.5999H10.4744C10.7715 17.5999 11.0686 17.4216 11.1874 17.184L17.6048 7.97386C17.9019 7.4985 17.783 6.9043 17.3671 6.6072C16.8917 6.25068 16.2381 6.36952 15.941 6.84488Z",
    fill: "#D0004B"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgSquareWithTick);
export default __webpack_public_path__ + "static/media/squareWithTick.bbfd6340268a51d630c53db0df094935.svg";
export { ForwardRef as ReactComponent };